import { couriersNode, functions } from '@/api/firebase'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'
import { COURIERS } from 'db'

const state = {
    routes: {},
    ...async()
}

const getters = {
    GET_ROUTES: (state) => state.routes,
    GET_ASYNC
}

const mutations = {
    SET_ROUTES(state, payload) {
        state.routes = payload
    },
    CLEAR_ROUTES(state) {
        state.routes = {}
    },
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== C/U/D Operations ===================================
    async CHANGE_ROUTE(_, payload) {
        await functions.httpsCallable('ordersUpdateRoute')({
            orderId: payload.orderId,
            routeId: payload.routeId,
            shouldEmail: payload.shouldEmail
        })
    },
    // =================================== Read Operations ===================================

    /**
     * FETCH_ORDER_COURIER_ROUTES
     *
     *     Retrieve an order's couriers route rules.
     *
     * @param payload.id {string} - The id of the courier to retrieve messages for.
     * @returns {void}
     */
    FETCH_ORDER_COURIER_ROUTES({ commit }, payload) {
        commit('REQUEST')
        commit('CLEAR_ROUTES')
        couriersNode
            .child(payload.id)
            .child(COURIERS.fields.routeRules)
            .on('value', (data) => {
                commit('SET_ROUTES', data.val())
                commit('SUCCESS')
            })
    },

    // =================================== Listener Operations ===================================

    /**
     * REMOVE_ORDER_COURIER_ROUTES_REFERENCE
     *
     *     Unbind a firebase connection on a child that was set.
     *
     * @param payload.id {string} - The id of the courier.
     */
    REMOVE_ORDER_COURIER_ROUTES_REFERENCE({ commit }, payload) {
        commit('CLEAR')
        commit('CLEAR_ROUTES')
        couriersNode
            .child(payload.id)
            .child(COURIERS.fields.routeRules)
            .off()
    }
}

export { state, getters, mutations, actions }
